import React, { useState } from "react";
import TabPanel from "../../../components/TabPanel";

// material ui
import Typography from "@material-ui/core/Typography";

// import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { date } from "../../../utils/dateTime";
import defaultPoint from "../../../assets/images/pointImg.png";
import rewardSaya from "../../../assets/images/reward.svg";
import { Skeleton } from "@material-ui/lab";

export default function RiwayatPoint({ value, loading, point }) {
  const [dialogProduk, setDialogProduk] = useState(false);

  function ProdukDialog() {
    return (
      <Dialog
        open={dialogProduk}
        onClose={() => {
          setDialogProduk(false);
        }}
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
      >
        {/* <Header
          title="Riwayat Point"
          type="with-title"
          onClick={() => {
            setDialogProduk(false);
          }}
        /> */}
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => {
                setDialogProduk(false);
              }}
              style={{ marginRight: 15 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Riwayat Point</Typography>
          </div>
        </DialogTitle>
        {/* <Gap height={90} /> */}
        <DialogContent dividers style={{ background: "#efefef", padding: 10 }}>
          {/* <div style={{ marginTop: "75px" }}> */}
          {point?.length !== 0 ? (
            <>
              {point?.map?.((item) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: "10px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "90%",
                      }}
                    >
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                          // borderRadius: 50,
                        }}
                        src={defaultPoint}
                        alt="logo"
                      />
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              // noWrap={true}
                              color="secondary"
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.nilai} Point
                            </Typography>
                          </div>
                        </div>
                        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                          <Typography style={{ fontSize: 14 }}>
                            Point berhasil ditambahkan
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "darkgray" }}
                          >
                            {item?.updated_at
                              ? date(item?.updated_at?.toDate?.())
                              : date(item?.created_at?.toDate?.())}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        // marginRight: "1,5%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div>
                        <img
                          style={{
                            width: 24,
                            height: 24,
                            marginRight: "10px",
                            // borderRadius: 50,
                          }}
                          src={rewardSaya}
                          alt="logo"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100px",
                borderRadius: 8,
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "gainsboro",
              }}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  // marginTop: "2.5%",
                  fontWeight: "bold",
                }}
              >
                Tidak Ada Data
              </Typography>
            </div>
          )}
          {/* </div> */}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <TabPanel value={value} index="point">
      {point?.length !== 0 && !loading ? (
        <div style={{ marginLeft: -10, marginRight: -10, marginTop: -10 }}>
          {point
            ?.sort(
              (a, b) =>
                b?.created_at?.toMillis?.() - a?.created_at?.toMillis?.()
            )
            ?.map?.((item, index) => {
              if (index < 5) {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: "10px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "90%",
                      }}
                    >
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                          // borderRadius: 50,
                        }}
                        src={defaultPoint}
                        alt="logo"
                      />
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              // noWrap={true}
                              color="secondary"
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.nilai} Point
                            </Typography>
                          </div>
                        </div>
                        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                          <Typography style={{ fontSize: 14 }}>
                            Point berhasil ditambahkan
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "darkgray" }}
                          >
                            {item?.updated_at
                              ? date(item?.updated_at?.toDate?.())
                              : date(item?.created_at?.toDate?.())}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        // marginRight: "1,5%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div>
                        <img
                          style={{
                            width: 24,
                            height: 24,
                            marginRight: "10px",
                            // borderRadius: 50,
                          }}
                          src={rewardSaya}
                          alt="logo"
                        />
                      </div>
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
        </div>
      ) : (
        <>
          {loading ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100px",
                borderRadius: 8,
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "gainsboro",
              }}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  // marginTop: "2.5%",
                  fontWeight: "bold",
                }}
              >
                Tidak Ada Data
              </Typography>
            </div>
          )}
        </>
      )}
      {point?.length < 5 ? null : (
        <Typography
          color="primary"
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            cursor:"pointer"
          }}
          onClick={() => {
            setDialogProduk(true);
          }}
        >
          Lihat Lainnya
        </Typography>
      )}
      <ProdukDialog />
    </TabPanel>
  );
}
